import React, { useState } from "react";
import BookConsultModal from "../BookConsultModal";
import wp1 from '../../assets/crack1.jpg';
import wp2 from '../../assets/crack2.jpg';
import wp3 from '../../assets/crack3.jpg';
import wp4 from "../../assets/crack4.jpg";
import wp5 from "../../assets/crack5.jpg";
import { Hammer, Shield, Rocket, Eye } from "lucide-react";

const CrackRepair = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="font-serif text-gray-800 bg-[#fefcf8]">

      {/* HERO */}
      <section 
        className="relative h-[80vh] min-h-[500px] flex items-center"
        style={{ backgroundImage: `url(${wp1})`, backgroundSize: "cover", backgroundPosition: "center" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-2xl text-white">
            <h1 className="text-4xl md:text-5xl font-serif font-semibold leading-tight">
              Crack Repair Solutions
            </h1>
            <p className="mt-6 text-lg text-gray-200 font-sans">
              Expert crack repair services to strengthen structures, prevent leaks, and maintain safety.
            </p>
            <div className="mt-10 flex gap-4 font-sans">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-amber-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-amber-700 transition shadow-lg"
              >
                Get Free Inspection
              </button>
              <button
                onClick={() => setIsModalOpen(true)}
                className="border border-white/40 text-white px-8 py-3 rounded-lg hover:bg-white/10 transition"
              >
                Talk to Expert
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 1: DYNAMIC OVERLAY GRID */}
      <section className="relative py-32">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-16 -left-16 w-[500px] h-[500px] bg-amber-200/20 rounded-full animate-pulse-slow"></div>
          <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-blue-200/20 rounded-full animate-spin-slow"></div>
        </div>
        <div className="relative max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-700 mb-6">
            Micro-Cracks Can Hide Big Problems
          </h2>
          <p className="text-gray-700 mb-16 text-lg max-w-3xl mx-auto">
            Invisible cracks compromise your walls and ceilings. Our technology detects and repairs them before they become costly disasters.
          </p>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { icon: <Hammer size={28} />, title: "Quick Detection", desc: "Identify hidden cracks instantly." },
              { icon: <Shield size={28} />, title: "Structural Protection", desc: "Prevent future damage." },
              { icon: <Rocket size={28} />, title: "Fast Repairs", desc: "High-speed interventions for minimal disruption." },
              { icon: <Eye size={28} />, title: "Detailed Monitoring", desc: "Track repaired areas for long-term safety." },
            ].map((item, i) => (
              <div key={i} className="bg-white p-10 rounded-3xl shadow-2xl hover:shadow-3xl transition hover:-translate-y-3 text-center relative">
                <div className="w-16 h-16 mx-auto mb-5 rounded-xl bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center text-white text-2xl">{item.icon}</div>
                <h3 className="font-semibold text-xl mb-2">{item.title}</h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 2: HORIZONTAL “FLOW” FEATURE */}
      <section className="py-32 bg-gradient-to-b from-amber-50 to-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center gap-12">
          <div className="md:w-1/2 space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-amber-700">
              Innovative Repair Flow
            </h2>
            <p className="text-gray-700 text-lg">
              Our team follows a precision-based repair process, using advanced materials and techniques to ensure cracks are sealed and protected for the long term.
            </p>
            <ul className="space-y-4 text-gray-600 text-sm">
              <li>• AI-powered crack detection</li>
              <li>• Micro-crack sealing technology</li>
              <li>• High-durability polymer coatings</li>
              <li>• Real-time monitoring for safety</li>
            </ul>
          </div>
          <div className="md:w-1/2 rounded-3xl overflow-hidden shadow-xl">
            <img src={wp2} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
          </div>
        </div>
      </section>
      {/* SECTION 9: MATERIALS & TECHNOLOGY */}
<section className="py-32 bg-white">
  <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
    
    <div>
      <h2 className="text-4xl md:text-5xl font-bold text-amber-700 mb-6">
        Materials & Technology We Use
      </h2>
      <p className="text-gray-700 mb-6 leading-relaxed">
        We use only industry-approved chemical formulations and 
        structural repair materials to ensure maximum durability.
      </p>

      <ul className="space-y-3 text-gray-700">
        <li>✔ Epoxy Injection Systems</li>
        <li>✔ Polyurethane Sealants</li>
        <li>✔ Carbon Fiber Mesh</li>
        <li>✔ Nano Polymer Coatings</li>
        <li>✔ Anti-corrosion Treatments</li>
      </ul>
    </div>

    <div className="bg-amber-50 rounded-3xl p-10 shadow-xl">
      <h3 className="text-2xl font-semibold mb-4">
        Why Our Materials Are Better?
      </h3>
      <p className="text-gray-700 leading-relaxed">
        Unlike cheap fillers, our materials chemically bond with 
        concrete, providing flexible and waterproof structural 
        repair that lasts for years.
      </p>
    </div>

  </div>
</section>


      {/* SECTION 3: VISUAL SHOWCASE */}
      <section className="py-32 max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-amber-700 text-center mb-12">
          Real Results, Real Strength
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {[wp4, wp5, wp3].map((img, i) => (
            <div key={i} className="group relative overflow-hidden rounded-3xl shadow-2xl">
              <img src={img} className="w-full h-full object-cover min-h-[300px] transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition flex items-center justify-center text-white font-bold text-lg">
                {i === 0 ? "Wall Stabilized" : i === 1 ? "Crack Sealed" : "Long-Term Protection"}
              </div>
            </div>
          ))}
        </div>
      </section>

{/* SECTION 10: WARRANTY */}
<section className="py-32 bg-gradient-to-r from-amber-100 to-amber-50">
  <div className="max-w-5xl mx-auto px-6 text-center">
    <h2 className="text-4xl md:text-5xl font-bold text-amber-700 mb-6">
      Our Warranty & Guarantee
    </h2>
    <p className="text-gray-700 mb-10 text-lg">
      We stand behind our work with written warranty and quality assurance.
    </p>

    <div className="grid md:grid-cols-3 gap-10">
      <div className="bg-white p-10 rounded-3xl shadow-xl">
        <h3 className="font-semibold text-xl mb-2">
          5+ Years Warranty
        </h3>
        <p className="text-gray-600 text-sm">
          Long-term protection on crack repairs.
        </p>
      </div>

      <div className="bg-white p-10 rounded-3xl shadow-xl">
        <h3 className="font-semibold text-xl mb-2">
          Free Re-Inspection
        </h3>
        <p className="text-gray-600 text-sm">
          Follow-up inspection after completion.
        </p>
      </div>

      <div className="bg-white p-10 rounded-3xl shadow-xl">
        <h3 className="font-semibold text-xl mb-2">
          No Hidden Cost
        </h3>
        <p className="text-gray-600 text-sm">
          Transparent pricing with no surprises.
        </p>
      </div>
    </div>
  </div>
</section>


      {/* SECTION 4: UNIQUE CTA */}
      <section className="py-32 bg-gradient-to-r from-amber-100 to-amber-50 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="w-96 h-96 bg-blue-200/20 rounded-full absolute -top-32 -left-32 animate-spin-slow"></div>
          <div className="w-80 h-80 bg-amber-200/20 rounded-full absolute -bottom-32 -right-16 animate-pulse-slow"></div>
        </div>
        <div className="relative max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-amber-700 mb-6">
            Protect Your Home from Hidden Cracks
          </h2>
          <p className="text-gray-700 mb-10 text-lg">
            Book a free inspection now and ensure your walls and ceilings are safe, strong, and crack-free.
          </p>
          <button
            onClick={() => setIsModalOpen(true)}
            className="px-12 py-4 bg-gradient-to-r from-amber-600 to-amber-800 text-white rounded-full font-semibold shadow-lg hover:scale-105 transition-transform"
          >
            Book Free Inspection
          </button>
        </div>
      </section>

      <BookConsultModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default CrackRepair;
